
export class CreateCampaignAction {
}

CreateCampaignAction.schema = {
    type: 'object',
    properties: {
        title: {type: 'string'},
        questions: {
        	type: 'array',
        	minItems: 1,
            items: {type: 'string'}
        },
        notationScale: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'object',
                properties: {
                    position: {type: 'number'},
                    label: {type: 'string'}
                },
                required: ['position', 'label']
            }
        }
    },
    required: ['title', 'questions', 'notationScale']
}


export class UpdateNotationScaleOfCampaignAction {
}

UpdateNotationScaleOfCampaignAction.schema = {
    type: 'object',
    properties: {
        newNotationScale: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'object',
                properties: {
                    position: {type: 'number'},
                    label: {type: 'string'}
                },
                required: ['position', 'label']
            }
        }
    },
    required: ['newNotationScale']
}

export class UpdateTitleOfCampaignAction {
}

UpdateTitleOfCampaignAction.schema = {
    type: 'object',
    properties: {
        newTitle: {type: 'string'}
    },
    required: ['newTitle']
}

export class AddQuestionToCampaignAction {
}

AddQuestionToCampaignAction.schema = {
    type: 'object',
    properties: {
        question: {type: 'string'}
    },
    required: ['question']
}

export class DefineAnswerRateGoalAction {
}

DefineAnswerRateGoalAction.schema = {
    type: 'object',
    properties: {
        rate: {type: 'number'}
    },
    required: ['rate']
}

export class StartCampaignAction {
}

StartCampaignAction.schema = {
    type: 'object',
    properties: {
        elligibleCreateTicketDate: {type: 'date'}
    },
    required: ['elligibleCreateTicketDate']
}

export class AnswerAction {
}

AnswerAction.schema = {
    type: 'object',
    properties: {
        answers: {
            type: 'array',
            items: {
                type: 'object'
            }
        },
        comment: {type: ['string', 'null']}
    },
    required: ['answers']
}


// WEBPACK FOOTER //
// ./lib/satisfaction/models.js